

import { FC, PropsWithChildren, ReactNode } from 'react';

import { Stack, Text } from '@eneco/sparky';
import { StackProps } from '@eneco/sparky/types';

type Props = Pick<StackProps, 'gap'>;

interface CompoundChecklistProps {
  Item: typeof Item;
}

interface ItemProps {
  gap?: Props['gap'];
  icon: ReactNode;
  children: string | ReactNode;
}

const Item: FC<ItemProps> = ({ icon, gap = '2', children }) => (
  <Stack as="li" direction="row" gap={gap}>
    <Stack.Item shrink={false}>{icon}</Stack.Item>
    <Text>{children}</Text>
  </Stack>
);

/** @deprecated Use `IconList` from the `Sprarky` library instead */
export const Iconlist: FC<PropsWithChildren<{ gap?: Props['gap'] }>> & CompoundChecklistProps = ({
  gap = '1',
  children,
}) => (
  <Stack as="ul" direction="column" gap={gap}>
    {children}
  </Stack>
);

Iconlist.Item = Item;
